import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  align-items: center;
`

const IconWrapper = styled.div`
  display: inline-flex;
  margin-right: 8px;
`

const CustomRenderer = ({selection}) => {
  return (
    <Container>
      <IconWrapper>{selection.icon}</IconWrapper>
      {selection.label}
    </Container>
  )
}

CustomRenderer.propTypes = {
  selection: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.node
  }).isRequired
}

export default CustomRenderer
